import $ from 'jquery';

// Tags widget logic for the licensee form (DEA, NPI, NCPDP, provider identifiers, roles).
// Server-side data is passed via data-* attributes on #licensee-form-config.
$(document).ready(function() {
  const formConfig = document.getElementById('licensee-form-config');
  if (!formConfig) return;

  const d = formConfig.dataset;
  const isReadOnly = d.action === 'show';
  const activePaneParam = d.activePane;

  // ---- Tags helper class ----
  var Tags = function(tags_container, tags_errors_container, prefill, hidden_field_name, validationMethod) {
    this.validationMethod = validationMethod;

    this.validate = function(tag) {
      return validationMethod(tag) === "";
    };

    var add_button = tags_container + '_btn';

    $(add_button).click(function() {
      var add_val = $(tags_container).val();
      $(tags_container).tagsManager('pushTag', add_val);
    });

    $(tags_container).on('tm:invalid', function(e, taglist) {
      $(tags_errors_container).text(validationMethod(taglist));
    });

    $(tags_container).tagsManager({
      prefilled: prefill,
      delimiters: [9, 13, 44],
      validator: this.validate,
      backspace: [],
      hiddenTagListName: hidden_field_name,
    });
  };

  // Return validation message. Empty string if valid.
  var validateDEACallback = function(tag) {
    var pat = /^[A-Za-z]{1}[A-Za-z9]{1}\d{7}$/i;
    return pat.exec(tag) ? "" : "Expect two chars and 7 digits";
  };

  var validateNCPDPCallback = function(tag) {
    var pat = /^\d{7}$/i;
    return pat.exec(tag) ? "" : "Expect 7 digits";
  };

  var validateNPICallback = function(tag) {
    var pat = /^\d{10}$/i;
    return pat.exec(tag) ? "" : "Expect 10 digits";
  };

  new Tags("#dea_tags",          "#dea_identifiers_errors",  d.deaPrefilled,         "licensee[facility_dea_numbers_tags]",  validateDEACallback);
  new Tags("#npi_tags",          "#npi_identifiers_errors",  d.npiPrefilled,         "licensee[facility_npi_numbers_tags]",  validateNPICallback);
  new Tags("#ncpdp_tags",        "#ncpdp_identifiers_errors", d.ncpdpPrefilled,      "licensee[facility_ncpdp_numbers_tags]", validateNCPDPCallback);
  new Tags("#provider_dea_tags", "#provider_dea_errors",     d.providerDeaPrefilled, "licensee[provider_dea_numbers_tags]",  validateDEACallback);
  new Tags("#provider_npi_tags", "#provider_npi_errors",     d.providerNpiPrefilled, "licensee[provider_npi_numbers_tags]",  validateNPICallback);

  // ---- Role Tags ----
  var RoleTags = function(tags_container, prefill, hidden_field_name, add_button) {
    $(add_button).click(function() {
      var add_val = $('#role_tags_main_list option:selected').text();
      $(tags_container).tagsManager('pushTag', add_val);
    });

    $(tags_container).tagsManager({
      prefilled: prefill,
      delimiters: [9, 13, 44],
      backspace: [],
      hiddenTagListName: hidden_field_name,
      read_only: isReadOnly,
    });
  };

  new RoleTags("#role_tags", d.rolePrefilled, "licensee[role_report_tags]", "#role_tags_btn");

  // ---- Tab handling ----
  if (activePaneParam) {
    $(`a[href="#${activePaneParam}-pane"]`).tab('show');
  }

  $('[data-toggle="tab"]').on('click', function() {
    var tab = $(this).attr('href').replace('#', '').replace('-pane', '');
    $('#active_pane').val(tab);
  });
});
